import { render, staticRenderFns } from "./Pos-menu-stock.vue?vue&type=template&id=42deca0e&"
import script from "./Pos-menu-stock.vue?vue&type=script&lang=js&"
export * from "./Pos-menu-stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports